var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRiskAnalysis = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 20,
    fill: "#DDE2EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4238 14C15.9584 14 14.7695 15.068 14.7695 16.3876C14.7695 17.7058 15.9584 18.7751 17.4238 18.7751C18.8892 18.7751 20.078 17.7058 20.078 16.3876C20.078 15.068 18.8892 14 17.4238 14Z",
    fill: "#7E8899"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.58 15.5938C30.1146 15.5938 28.9258 16.6617 28.9258 17.9813C28.9258 19.2995 30.1146 20.3689 31.58 20.3689C33.0454 20.3689 34.2342 19.2995 34.2342 17.9813C34.2342 16.6617 33.0454 15.5938 31.58 15.5938Z",
    fill: "#7E8899"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5019 18.7734C23.0365 18.7734 21.8477 19.8414 21.8477 21.161C21.8477 22.4792 23.0365 23.5481 24.5019 23.5481C25.9673 23.5481 27.1561 22.479 27.1561 21.161C27.1561 19.8414 25.9673 18.7734 24.5019 18.7734Z",
    fill: "#7E8899"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9278 21.957L27.1582 33.0989H34.2362V21.957H28.9278Z",
    fill: "#03002F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20.3672V29.1215H14.7696V33.1008H18.2739L20.078 24.985V20.3672H13Z",
    fill: "#03002F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6322 25.1445H21.8474L20.0781 33.1033H25.3693L26.6322 25.1445Z",
    fill: "#03002F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRiskAnalysis);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/riskAnalysis.2dcc1bb9cb1229845b86292b54475211.svg";